import { isFSA } from 'flux-standard-action'
import invariant from 'invariant'
import {
  CUSTOMER_LIST_SET_CUSTOMERS,
  CUSTOMER_LIST_SET_CUSTOMER_DETAIL,
  CUSTOMER_LIST_SET_RECEIPT,
  CUSTOMER_LIST_SET_TOTAL_PAGE,
  CUSTOMER_LIST_SET_CURRENT_PAGE,
  CUSTOMER_LIST_SET_KEYWORD,
  CUSTOMER_LIST_SET_TYPE,
  CUSTOMER_LIST_SET_SUMMARY,
  CUSTOMER_LIST_SHOW_IMPORTING_MODE_MODAL,
  CUSTOMER_LIST_HIDE_IMPORTING_MODE_MODAL,
  CUSTOMER_LIST_SET_REDEMPTION_HISTORIES,
  CUSTOMER_LIST_SET_POINT_ACTIVITIES,
  CUSTOMER_LIST_SET_HAS_LOYALTY
} from 'actions/customers/list/constants'

let initialState = {
  customers: [],
  currentPage: null,
  totalPage: null,
  customerDetail: null,
  summary: {
    total_customer: 0,
    total_loyalty_member: 0,
    total_rewards_redeemed: 0
  },
  redemptionHistories: null,
  pointActivities: null,
  receiptData: null,
  keyword: null,
  showImportingModeModal: false,
  type: null,
  hasLoyalty: null
}

function reducer (state = initialState, action) {
  invariant(
    isFSA(action),
    `Invalid FSA action. See https://github.com/acdlite/flux-standard-action for info. Object: ${JSON.stringify(action)}`
  )
  let {payload} = action
  switch (action.type) {
    case CUSTOMER_LIST_SET_CUSTOMERS:
      return {...state, customers: payload.customers}
    case CUSTOMER_LIST_SET_CUSTOMER_DETAIL:
      return {...state, customerDetail: payload.customer}
    case CUSTOMER_LIST_SET_RECEIPT:
      return {...state, receiptData: payload.receiptData}
    case CUSTOMER_LIST_SET_TOTAL_PAGE:
      return {...state, totalPage: payload.totalPage}
    case CUSTOMER_LIST_SET_CURRENT_PAGE:
      return {...state, currentPage: payload.currentPage}
    case CUSTOMER_LIST_SET_KEYWORD:
      return {...state, keyword: payload.keyword}
    case CUSTOMER_LIST_SET_SUMMARY:
      return {...state, summary: payload.summary}
    case CUSTOMER_LIST_SHOW_IMPORTING_MODE_MODAL:
      return {...state, showImportingModeModal: true}
    case CUSTOMER_LIST_HIDE_IMPORTING_MODE_MODAL:
      return {...state, showImportingModeModal: false}
    case CUSTOMER_LIST_SET_TYPE:
      return {...state, type: payload.type}
    case CUSTOMER_LIST_SET_REDEMPTION_HISTORIES:
      return {...state, redemptionHistories: payload.redemptionHistories}
    case CUSTOMER_LIST_SET_POINT_ACTIVITIES:
      return {...state, pointActivities: payload.pointActivities}
    case CUSTOMER_LIST_SET_HAS_LOYALTY:
      return {...state, hasLoyalty: payload.hasLoyalty}
    default:
      return {...state}
  }
}

export default reducer



// WEBPACK FOOTER //
// ./app/reducers/customers/list.js